<template>
  <div class="box text-center">
    <!-- /.box-header -->
    <div class="box-body">
      <div class="col-xs-12 y-middle">
        <div class="inline-block pull-left text-left">
          <h4 v-if="storeName">
            {{storeName}}
          </h4>
          <h5 v-if="$route.name === 'reDisProduct'"><span class="text-red">＊</span> 未勾選解除停賣的項目，會保持原門市設定。</h5>
          <h5 v-else-if="$route.name === 'disProduct'"><span class="text-red">＊</span> 未勾選停賣的項目，會保持原門市設定。</h5>
          <h5 v-else><span class="text-red">＊</span> 未勾選者，將會取消停賣功能。</h5>

          <h5 v-if="$route.name == 'reDisProduct'"><span class="text-red">＊</span> 各分類中若有相同料號的商品，會同步解除停賣。</h5>
          <h5 v-else-if="$route.name === 'disProduct'"><span class="text-red">＊</span> 各分類中若有相同料號的商品，會同步停賣。</h5>
          <h5 v-else><span class="text-red">＊</span> 各分類中若有相同料號的商品，會同步停賣、解除停賣。</h5>

          <h5 v-if="isDaily"><span class="text-red">＊</span> 系統將於您的商店打烊後，自動解除停賣當日停賣商品。</h5>
          <h5 v-if="isDaily"><span class="text-red">＊</span> 當日打烊後及公休日無法進行設定，跨日後若無遇公休可設定。</h5>
          <h5 v-if="isDaily"><span class="text-red">＊</span> 如您有其他的設定需求，可使用「時段停賣管理」、「永久停賣」進行設定。</h5>
        </div>
      </div>
      <div class="col-xs-12 dialy-hint" v-if="isDayOff">
        <span class="text-red">＊</span> {{ isDayOff }}
      </div>
      <div class="col-xs-12 y-middle" v-if="category.length>0"><div class="hr-line"></div>
        <div v-if="$route.name === 'reDisProduct'" class="h3-title">商品解除{{timeType}}停賣設定</div>
        <div v-else class="h3-title">商品{{timeType}}停賣設定</div>
      </div>
      <div class="col-xs-12 p-10">
        <div class="grid" style="width: 100%;">
          <div class="col-xs-12 col-lg-4 grid-item p-5" v-for="(c, index) in category">
            <div class="col-xs-12 card">
              <div class="col-xs-12 m-b-5 text-left p-x-15">
                <div class="text-right inline-block block-checkbox text-15" style="margin-right: 10px;">
                  <span v-if="$route.name === 'reDisProduct'" class="text-dark-gray text-13">解除停賣</span>
                  <span v-else class="text-dark-gray text-13">停賣</span>
                  <!--<span class="text-dark-gray text-13" style="margin-left: 18px;">訂購</span>-->
                  <!--<span class="text-dark-gray text-13" style="margin-left: 18px; margin-right: 5px;">顯示</span>-->
                </div>
              </div>
              <div class="col-xs-12 card-title text-left p-x-15">
                <span class="pull-left">{{c.name}} <small>{{c.remark}}</small></span>
                <div class="text-right inline-block m-r-15 block-checkbox">
                  <span v-if="$route.name === 'reDisProduct'" class="checkbox-addmenu">
                    <input type="checkbox" v-model="c.is_disabled" :id="'c-' + c.product_id + '-is-add'" @input="changeCategoryAdd(c)">
                  </span>
                  <span v-else class="checkbox-addmenu">
                    <input type="checkbox" v-model="c.is_disabled" :id="'c-' + c.product_id + '-is-add'" class="css-checkbox" @input="changeCategoryAdd(c)">
                    <label :for="'c-' + c.product_id + '-is-add'" class="css-label css-label-add"></label>
                  </span>
                </div>
              </div>
              <div class="col-xs-12 text-left">
                <ul class="nav p-x-15">
                  <li class="card-product" v-for="(p, index) in c.child_list">
                    <!--解除停賣不會有刪除線-->
                    <div :class="p.is_disabled && $route.name !== 'reDisProduct'?'delete-line':''">
                      {{p.name}} <small>{{p.remark? `(${p.remark})`: ''}}</small>
                      <div class="text-right inline-block block-checkbox">
                        <span v-if="$route.name === 'reDisProduct'" class="checkbox-addmenu">
                          <input type="checkbox" v-model="p.is_disabled" :id="'p-' + p.product_id + '-is-add'" @input="changeProductAdd(c, p)">
                        </span>
                        <span v-else class="checkbox-addmenu">
                          <input type="checkbox" v-model="p.is_disabled" :id="'p-' + p.product_id + '-is-add'" class="css-checkbox"  @input="changeProductAdd(c, p)">
                          <label :for="'p-' + p.product_id + '-is-add'" class="css-label css-label-add"></label>
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 y-middle m-t-10 m-b-10" v-if="optionsAll && optionsAll.length > 0 && $route.name === 'reDisProduct'"><div class="hr-line"></div><div class="h3-title">配料解除{{ timeType }}停賣設定</div></div>
      <div class="col-xs-12 y-middle m-t-10 m-b-10" v-else-if="optionsAll && optionsAll.length > 0"><div class="hr-line"></div><div class="h3-title">配料{{ timeType }}停賣設定</div></div>
      <div class="col-xs-12 p-10" v-if="optionsAll && optionsAll.length > 0">
        <div class="gridI" style="width: 100%;">
          <div class="col-xs-12 col-lg-4 grid-itemI p-5" v-for="(ot, otIndex) in optionsAll">
            <div class="col-xs-12 card">
              <div class="col-xs-12 m-b-5 text-left p-x-15">
                <div class="text-right inline-block block-checkbox text-15" style="margin-right: 10px;">
                  <span v-if="$route.name === 'reDisProduct'" class="text-dark-gray text-13">解除停賣</span>
                  <span v-else class="text-dark-gray text-13">停賣</span>
                </div>
              </div>
              <div class="col-xs-12 card-title text-left p-x-15">
                <span class="pull-left">{{ot.name}} <small>{{ot.remark}}</small></span>
                <div class="text-right inline-block m-r-15 block-checkbox">
                  <span  v-if="$route.name === 'reDisProduct'" class="checkbox-addmenu">
                    <input v-model="ot.is_disabled" type="checkbox" :id="'o-' + ot.product_id + '-is-add'" @input="changeAdjustAddAll(ot)">
                  </span>
                  <span  v-else class="checkbox-addmenu">
                    <input v-model="ot.is_disabled" type="checkbox" :id="'o-' + ot.product_id + '-is-add'" class="css-checkbox" @input="changeAdjustAddAll(ot)">
                    <label :for="'o-' + ot.product_id + '-is-add'" class="css-label css-label-add"></label>
                  </span>
                </div>
              </div>
              <div class="col-xs-12 text-left">
                <ul class="nav p-x-15">
                  <li class="card-product" v-for="(a, index) in ot.child_list">
                    <!--解除停賣不會有刪除線-->
                    <div :class="a.is_disabled && $route.name !== 'reDisProduct'?'delete-line':''">
                      {{a.name}} <small>{{a.remark? `(${a.remark})`: ''}}</small>
                      <div class="text-right inline-block block-checkbox">
                        <span v-if="$route.name === 'reDisProduct'" class="checkbox-addmenu">
                          <input type="checkbox" v-model="a.is_disabled" :id="'a-' + a.product_id + '-is-add'" @input="checkAdjustAll(a, ot)">
                        </span>
                        <span v-else class="checkbox-addmenu">
                          <input type="checkbox" v-model="a.is_disabled" :id="'a-' + a.product_id + '-is-add'" class="css-checkbox" @input="checkAdjustAll(a, ot)">
                          <label :for="'a-' + a.product_id + '-is-add'" class="css-label css-label-add"></label>
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 p-10" v-if="!$route.params.store_id && $route.name === 'disProduct'">
        <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
          <hr>
          <div class="text-left">
            <h5>參與停賣店家
            </h5>
            <!-- 參與店家 -->
            <muti-select-two :setting="addStoresSetting"></muti-select-two>
            <!--{{addStoresSetting.choose}}-->
          </div>
        </div>
      </div>
      <div class="col-xs-12 p-10" v-else-if="!$route.params.store_id && $route.name === 'reDisProduct'">
        <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
          <hr>
          <div class="text-left">
            <h5>參與解除停賣店家
            </h5>
            <!-- 參與店家 -->
            <muti-select-two :setting="addStoresSetting"></muti-select-two>
            <!--{{addStoresSetting.choose}}-->
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-12 dialy-hint" v-if="isDayOff"></div>
    <div class="box-footer text-center" :class="{'box-border': !isDayOff}">
      <router-link to="/disItemTable">
        <button class="btn btn-default">
          取消
        </button>
      </router-link>
      <button class="btn btn-success" @click="gotoNext">
        確定
      </button>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import Masonry from 'masonry-layout'
import moment from 'moment'

export default {
  props: {
    'info': {
      type: Object
    }
  },
  data () {
    return {
      menuId: this.$route.params.menu_id,
      brandId: this.$route.params.brand_id,
      storeId: this.$route.params.store_id,
      menus: {
        category_list: [],
        adjust_list: [],
        option_list: {
          option_map: {},
          vendor_map: {}
        }
      },
      category: [], // 商品停賣設定
      optionsAll: [], // 配料停賣設定
      product: [],
      // if created checkbox all true, if not all false
      created: false,
      getTimes: 0,
      time: 0,
      addStoresSetting: {
        class: 'add-store',
        options: [],
        choose: []
      },
      offdayInfo: {
        date: [],
        month_day: [],
        week_day: []
      },
      startTime: '',
      endTime: '',
      dailyDisabledList: []
    }
  },
  methods: {
    async menuInit () {
      await this.getMenuInfo()
      if (this.isDaily) {
        await this.getStoreInfo()
        await this.getDailyDisabledList()
      }
      this.disabledInit()
    },
    changeAdjustAddAll (op) {
      op.is_disabled = !op.is_disabled
      op.child_list.forEach(function (o) {
        o['is_disabled'] = op.is_disabled
      })
    },
    checkAdjustAll (o, ot) {
      o.is_disabled = !o.is_disabled
      const isDisabled = ot.child_list.filter(x => x.is_disabled === 0)
      if (isDisabled.length === 0) {
        ot.is_disabled = false
      }
    },
    showMenu () {
      if ($('.grid') && $('.grid-item')) {
        var m = new Masonry('.grid', {
          itemSelector: '.grid-item',
          columnWidth: '.grid-item'
        })
        m.reloadItems()
        m.layout()
      }
    },
    showIngred () {
      // 參考showMenu 使用瀑布套件，使每個grid能夠緊密連結
      if ($('.gridI') && $('.grid-itemI')) {
        var m = new Masonry('.gridI', {
          itemSelector: '.grid-itemI',
          columnWidth: '.grid-itemI'
        })
        m.reloadItems()
        m.layout()
      }
    },
    gotoNext () {
      // this.joinMenu()
      if (!this.addStoresSetting.choose.length && !this.storeId) {
        if (this.$route.name === 'disProduct') {
          this.$notify({
            title: '請選擇停賣商品',
            text: '請選擇停賣商品',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } else if (this.$route.name === 'reDisProduct') {
          this.$notify({
            title: '請選擇解除停賣商品',
            text: '請選擇解除停賣商品',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        }
      } else this.disProductList()
      // this.$router.push('/crJoinMenu')
    },
    async getMenuInfo () {
      var url = '/onlineMenu/' + this.menuId + '/productBrief'
      if (this.storeId) {
        url += '?store_id=' + this.storeId
      }
      await new Promise((resolve) => {
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            this.menus = response.data.brief
            this.addStoresSetting.options = response.data.store_list.map(x => {
              return {
                value: x.id,
                label: x.name
              }
            })
          }
          resolve()
        })
      })
    },
    disProductList () {
      var stores = this.addStoresSetting.choose.length > 0 ? this.addStoresSetting.choose : [Number(this.storeId)]
      let productAry = []
      let packageAry = []
      let optionAry = []
      this.category.forEach(k => {
        const product = k.child_list.filter(x => x.type === 1 && x.is_disabled).map(j => j.product_id)
        if (product.length > 0) {
          productAry = [...productAry, product]
        }
        const packages = k.child_list.filter(x => x.type === 3 && x.is_disabled).map(j => j.product_id)
        if (packages.length > 0) {
          packageAry = [...packageAry, packages]
        }
      })
      this.optionsAll.forEach(z => {
        z.child_list.forEach(zi => {
          if (zi.is_disabled) {
            optionAry.push(zi.product_id)
          }
        })
      })
      let data = {}
      if (this.$route.name === 'reDisProduct') {
        // 解除停賣
        data = {
          store_list: stores,
          setting: {
            product_list: {
              enable: productAry.flat()
            },
            package_list: {
              enable: packageAry.flat()
            },
            option_list: {
              enable: optionAry.flat()
            }
          },
          keep_product_status: 0
        }
      } else {
        // 停賣和多店停賣
        data = {
          store_list: stores,
          setting: {
            product_list: {
              disable: productAry.flat()
            },
            package_list: {
              disable: packageAry.flat()
            },
            option_list: {
              disable: optionAry.flat()
            }
          },
          keep_product_status: 0
        }
      }
      if (this.$route.name === 'reDisProduct' || this.$route.name === 'disProduct') {
        data.keep_product_status = 1
      }
      var url = `/onlineMenu/${this.$route.params.menu_id}/productListStatus`

      if (this.isDaily) {
        if (this.storeId) url = `/store/${this.storeId}/productDisableTodayScheduleSetting`
        let disabledList = [...productAry.flat(), ...optionAry.flat(), ...packageAry.flat()]
        data = { item_list: [] }

        disabledList.forEach(id => {
          let typeKeys = ['adjust_list', 'category_list']
          typeKeys.forEach(key => {
            let menuTypes = this.menus[key]
            menuTypes.forEach(group => {
              let itemList = group.child_list
              itemList.forEach(item => {
                if (item.product_id !== id) return
                let obj = {
                  product_type: item.type,
                  src_id_type: item.vendor_custom_id ? 1 : 2,
                  vendor_custom_id: item.vendor_custom_id,
                  product_id: id
                }
                data.item_list.push(obj)
              })
            })
          })
        })
      }

      this.getDataH('post', url, data, (response) => {
        this.$router.go(-1)
        if (response.data.status === 200) {
          this.$notify({
            title: '訊息',
            text: '成功更新停賣資訊',
            duration: 3000,
            type: 'success',
            width: 400
          })
        }
      })
    },
    changeCategoryAdd (category) {
      category.is_disabled = !category.is_disabled
      category.child_list.forEach(function (product) {
        product['is_disabled'] = category.is_disabled
      })
    },
    changeProductAdd (category, product) {
      product.is_disabled = !product.is_disabled
      this.category.forEach((x) => {
        x.child_list.forEach(y => {
          // 料號相同，但產品ID不同
          if (y.vendor_custom_id === product.vendor_custom_id && y.product_id !== product.product_id) {
            y.is_disabled = product.is_disabled
          }
        })
      })
      const isDisabled = category.child_list.filter(x => x.is_disabled === 0)
      if (isDisabled.length === 0) {
        category.is_disabled = false
      }
    },
    async getDailyDisabledList () {
      this.dailyDisabledList = []
      if (!this.storeId) return

      const url = `/store/${this.storeId}/productDisableTodayScheduleSetting`
      let date = moment().format('YYYY-MM-DD')
      await new Promise((resolve) => {
        this.getDataH('get', url, { date }, (response) => {
          if (response.data.status === 200) {
            let date = moment().format('YYYY-MM-DD')
            let startTime = this.startTime.split(' ')[1]
            let endTime = this.endTime.split(' ')[1]
            let disabledData = response.data.list.find(item => item.date === date && item.start_time === startTime && item.end_time === endTime)
            if (!disabledData && response.data.list.length) disabledData = response.data.list[0] // TODO: 這行 api 修好之後要刪掉
            if (disabledData) this.dailyDisabledList = disabledData.item_list
          }
          resolve()
        })
      })
    },
    async getStoreInfo () { // 取得門市營業時間
      if (!this.storeId) return
      const url = `/store/${this.storeId}/info`

      await new Promise((resolve) => {
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            let info = response.data.info
            this.$store.commit('SET_STORE_INFO', info)
            let openInfo = info.opening_info
            // week_day 週日是 1, 週一是 2, 以此類推, 找出當日營業時間

            let todayOpenInfo = openInfo.find(day => day.week_day === moment().day() + 1)
            this.offdayInfo = info.offday_info
            this.startTime = moment().format('YYYY-MM-DD ') + todayOpenInfo.start_time
            this.endTime = moment().format('YYYY-MM-DD ') + todayOpenInfo.end_time
          }
          resolve()
        })
      })
    },
    disabledInit () {
      let typeKeys = ['adjust_list', 'category_list']

      // 設定當日停賣
      if (this.isDaily) {
        console.log(this.dailyDisabledList)
        typeKeys.forEach(key => {
          let menuTypes = this.menus[key]
          menuTypes.forEach(group => {
            let itemList = group.child_list
            itemList.forEach(itemA => {
              let isDisabled = this.dailyDisabledList.find(itemB => itemA.vendor_custom_id === itemB.vendor_custom_id)
              if (isDisabled && !this.isDayOff) itemA.is_disabled = 1
              else itemA.is_disabled = 0
            })
          })
        })
      }

      // 紀錄所有商品
      this.category = this.menus.category_list.map(category => {
        const allDisabled = category.child_list.every(k => k.is_disabled)
        if (allDisabled) category.is_disabled = true
        else category.is_disabled = false
        return category
      })

      // 紀錄所有配料
      this.optionsAll = this.menus.adjust_list
        .filter(adjust => adjust.sub_type === 0)
        .map(adjust => {
          const allDisabled = adjust.child_list.every(k => k.is_disabled)
          if (allDisabled) adjust.is_disabled = true
          else adjust.is_disabled = false
          return adjust
        })
    }
  },
  created () {
    this.menuInit()
  },
  mounted () {
    this.showMenu()
    this.showIngred()
  },
  updated () {
    this.showMenu()
    this.showIngred()
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    checkInput () {
      return this.$parent.checkInput
    },
    storeName () {
      var sId = parseInt(this.$route.params.store_id, 10)
      if (sId) {
        var sName = this.addStoresSetting.options.find(function (o) { return sId === o.value })
        if (sName) return sName.label + '菜單'
      }
      return ''
    },
    isDaily () {
      let name = this.$route.name
      return name === 'disProductStoreDaily'
    },
    isDayOff () {
      if (!this.isDaily) return ''
      let now = moment().format('YYYY-MM-DD HH:mm:ss')
      let isAfterEnd = moment(now).isAfter(this.endTime)
      if (isAfterEnd) return '門市今日已打烊，請於明日再進行設定。'

      let today = moment().format('YYYY-MM-DD')
      let weekDay = moment().day() + 1
      let monthDay = moment().date()
      let { date, week_day, month_day } = this.offdayInfo
      let isOffday = date.includes(today) || week_day.includes(weekDay) || month_day.includes(monthDay)
      if (isOffday) return '門市公休中，請於非公休時間進行設定。'

      return ''
    },
    timeType () {
      if (this.isDaily) return '當日'
      return '永久'
    }
  }
}
</script>
<style lang="sass" scoped>
  $default-color: #e1456d
  $light-gray: rgb(238, 238, 238)
  .label-text-60-p
    font-size: 60% !important
  .m-t-10
    margin-top: 10px !important
  .m-b-5
    margin-bottom: 5px !important
  .m-r-5
    margin-right: 5px !important
  .m-r-20
    margin-right: 20px !important
  .m-r-15
    margin-right: 15px !important
  .block-checkbox
    right: 0px
    position: absolute
    top: 3px
  .card-title .block-checkbox
    top: 8px
  .checkbox-visible, .checkbox-enable
    margin-left: 20px
  .text-dark-gray
    color: #333 !important
  .text-light-gray
    color: #666 !important
  .text-13
    font-size: 13px !important
  .btn-option-show
    background: #ffffff
    border: 1px solid $default-color
    min-width: 100px
    font-size: 15px
    border-radius: 5px
    cursor: auto
  input[type="checkbox"]
    margin-left: 0
    padding: 0
  input[type=checkbox].css-checkbox
    position: absolute
    overflow: hidden
    clip: rect(0 0 0 0)
    height: 1px
    width: 1px
    margin: -1px
    padding: 0px
    border: 0
  input[type=checkbox].css-checkbox+label.css-label
    padding-left: 22px
    height: 16px
    width: 16px
    display: inline-block
    line-height: 15px
    background-repeat: no-repeat
    background-position: 0 0
    font-size: 13px
    vertical-align: middle
    cursor: pointer
    opacity: 1
  input[type=checkbox].css-checkbox+label.css-label:hover
    opacity: 0.5
  input[type=checkbox].css-checkbox:checked+label.css-label
    background-position: 0 -17px
  .css-label:not(.css-label-add)
    background-image: url(/static/img/checkbox.png)
    background-size: 16px
  .css-label.css-label-add
    background-image: url(/static/img/checkbox-delete.png)
    background-size: 16px
  input[type=checkbox].css-checkbox+label.css-label.disabled:hover
    opacity: 1
  .delete-line
    text-decoration: line-through;
  .box-border
    border-top: 1px solid #e1456d;;
  .h3-title
    color: #e1456d;
    font-size: 24px;
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #fff;
  .hr-line
    position: absolute;
    width: 100%;
    display: inline-lock;
    border-top: 1px solid #e1456d;
    top: 19px;
  small
    color: dimgrey

  .dialy-hint
    width: calc(100% - 10px)
    background: rgba(#3C8DBC, 0.1)
    border-radius: 4px
    border: 1px solid #3C8DBC
    text-align: left
    font-size: 14px
    padding: 10px 
    margin: 20px 5px 30px
    font-weight: bold
    ~ div
        position: relative
        &:after
          content: ""
          background: #fff
          opacity: 0.5  
          position: absolute
          top: 0
          left: 0
          z-index: 9
          width: 100%
          height: 100%
          cursor: not-allowed
</style>



// WEBPACK FOOTER //
// DisProdTemp.vue?012c442c